import type { FC, Ref } from "react";
import { TextField } from "../../../components";

export type HiddenFieldProxyProps = {
  value?: string;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLInputElement>;
};

/**
 * A proxy component for hidden form fields.
 * Renders nothing visually but allows value registration in form context.
 */
export const HiddenFieldProxy: FC<HiddenFieldProxyProps> = ({
  value,
  ref,
  ...props
}) => <TextField value={value} {...props} ref={ref} type="hidden" />;
